module.exports = __webpack_public_path__ + "static/media/insightAction.7cf8707f.png";